import React from "react";
import { Typography, Button, Box } from "@mui/material";

const OrderHeader = ({ isMobile, totalOrders, onCreate }) => {
  return (
    <Box sx={{ px: { xs: -20, sm: 3, md: 4 }, py: 3 }}>
      <Typography
        variant={isMobile ? "h6" : "h4"}
        gutterBottom
        sx={{ fontWeight: 700, mb: 4, mt: isMobile ? -4 : 4 }}
      >
        Quản lý Đơn hàng
      </Typography>
      <Box display="flex" alignItems="center" gap={2}>
        <Typography>{totalOrders} Đơn hàng</Typography>
        <Button variant="contained" color="primary" onClick={onCreate}>
          Tạo đơn hàng
        </Button>
      </Box>
    </Box>
  );
};

export default OrderHeader;